import React from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDateLocalNoTime, generalPostFunction } from "../Globals/globalFunctions";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { cardArray, gameCollectionArray, gamePorts, userLevelArray } from "../Globals/globalMetaData";
import { SvgIcon } from "../Components/SvgIcons";

function BetHistory() {
	const navigate = useNavigate();
	const locationState = useLocation().state;
	const [agentReport, setAgentReport] = useState([]);
	const [reportDate, setReportDate] = useState({
		startDate: formatDateLocalNoTime(new Date()),
		endDate: formatDateLocalNoTime(new Date()),
	});

	const [dateRangeType, setDateRangeType] = useState("today");
	const setAllPlayers = useSelector((state) => state.allPlayers.setAllPlayers);
	const account = JSON.parse(localStorage.getItem("account"));
	const [gameName, setGameName] = useState("");
	const [commisionpoint, setCommisionpoint] = useState(0);

	const [selectedSuperStockez, setSelectedSuperStockez] = useState("");
	const [selectedStockez, setSelectedStockez] = useState("");
	const [selectedMaster, setSelectedMaster] = useState("");
	const [selectedAgent, setSelectedAgent] = useState("");
	const [selectedPlayer, setSelectedPlayer] = useState("");

	const [accountType, setAccountType] = useState(userLevelArray.find((item) => item.name == "User").level);

	const [selectedUsername, setSelectedUsername] = useState();

	const [selectedItem, setSelectedItem] = useState({});

	useEffect(() => {
		const today = new Date();
		let startDate = new Date();
		let endDate = new Date(today); // default end date = today

		switch (dateRangeType) {
			case "today":
				startDate = today;
				endDate = today;
				break;

			case "yesterday":
				startDate = new Date(today);
				startDate.setDate(today.getDate() - 1);
				endDate = new Date(startDate); // both start & end = yesterday
				break;

			case "7_days":
				startDate = new Date(today);
				startDate.setDate(today.getDate() - 7);
				endDate = today;
				break;

			case "1_month":
				startDate = new Date(today);
				startDate.setMonth(today.getMonth() - 1);
				endDate = today;
				break;

			case "3_month":
				startDate = new Date(today);
				startDate.setMonth(today.getMonth() - 3);
				endDate = today;
				break;

			case "this_week": {
				const dayOfWeek = today.getDay();
				const daysSinceMonday = (dayOfWeek + 6) % 7;
				startDate = new Date(today);
				startDate.setDate(today.getDate() - daysSinceMonday);
				endDate = today;
				break;
			}

			case "last_week": {
				const dayOfWeek2 = today.getDay();
				const daysSinceMonday2 = (dayOfWeek2 + 6) % 7;

				// Last Monday
				startDate = new Date(today);
				startDate.setDate(today.getDate() - daysSinceMonday2 - 7);

				// Last Sunday
				endDate = new Date(startDate);
				endDate.setDate(startDate.getDate() + 6);
				break;
			}

			case "this_month":
				startDate = new Date(today.getFullYear(), today.getMonth(), 1);
				endDate = today;
				break;

			case "last_month":
				startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
				endDate = new Date(today.getFullYear(), today.getMonth(), 0); // last day of last month
				break;

			default:
				startDate = today;
				endDate = today;
		}

		setReportDate({
			startDate: formatDateLocalNoTime(startDate),
			endDate: formatDateLocalNoTime(endDate),
		});
	}, [dateRangeType]);

	const getReportByDate = async () => {
		try {
			const payload = {
				username: selectedUsername,
				startDate: reportDate.startDate,
				endDate: reportDate.endDate,
				names: gameName,
			};
			const response = await generalPostFunction("/getuserbetdetails_gamewise", payload, "3040");
			if (response.message == "success") {
				if (gameName !== "") {
					setAgentReport(
						response.result[gameName].map((item) => ({
							...item,
							gamename: gameName,
						})),
					);
				} else {
					const mergedGames = Object.entries(response.result).flatMap(([gameName, arr]) =>
						arr.map((item) => ({
							...item,
							gamename: gameName,
						})),
					);
					setAgentReport(mergedGames);
				}

				setCommisionpoint(response.commisionpoint);
			}
		} catch (err) {
			console.log(err);
		}
	};

	// useEffect(() => {
	// 	if (selectedPlayer) {
	// 		setSelectedUsername(selectedPlayer);
	// 	} else if (selectedAgent) {
	// 		setSelectedUsername(selectedAgent);
	// 	} else if (selectedMaster) {
	// 		setSelectedUsername(selectedMaster);
	// 	} else if (selectedStockez) {
	// 		setSelectedUsername(selectedStockez);
	// 	} else if (selectedSuperStockez) {
	// 		setSelectedUsername(selectedSuperStockez);
	// 	} else {
	// 		setSelectedUsername("");
	// 	}
	// }, [selectedSuperStockez, selectedStockez, selectedMaster, selectedAgent, selectedPlayer]);
	return (
		<>
			<div className="overviewTableWrapper">
				<div className="overviewTableChild">
					<div className="d-flex flex-wrap">
						<div className="col-12">
							<div className="heading">
								<div className="content">
									<h4>Bet History</h4>
								</div>
								<div className="buttonGroup">
									<button className="panelButton gray" onClick={() => navigate(-1)}>
										<span className="text">Back</span>
										<span className="icon">
											<SvgIcon name="back" />
										</span>
									</button>
								</div>
							</div>
						</div>
						<div className="col-12" style={{ overflow: "auto", padding: "10px 20px 0px" }}>
							<div className="tableHeader">
								<div className="d-flex justify-content-xl-end">
									{/* <div className="formRow border-0 ps-0">
                    <label className="formLabel text-start mb-0 w-100">
                      Account Type
                    </label>
                    <select
                      className="formItem"
                      value={accountType}
                      onChange={(e) => setAccountType(e.target.value)}
                    >
                      <option value={""}>Select Account Type</option>
                      {userLevelArray && userLevelArray.length > 0 ? (
                        userLevelArray
                          .filter((item) => item.level > account.level)
                          .map((item, index) => (
                            <option key={index} value={item.level}>
                              {item.name}
                            </option>
                          ))
                      ) : (
                        <option>No Account Found!</option>
                      )}
                    </select>
                  </div> */}
									<div className="formRow border-0 ps-0">
										<label className="formLabel text-start mb-0 w-100">Player</label>
										<select className="formItem" value={selectedUsername} onChange={(e) => setSelectedUsername(e.target.value)}>
											<option value={""}>Select Player</option>
											{setAllPlayers && setAllPlayers.length > 0 ? (
												setAllPlayers
													.filter((item) => item.level == accountType)
													.map((item, index) => (
														<option key={index} value={item.username}>
															{item.username}
														</option>
													))
											) : (
												<option>No Account Found!</option>
											)}
										</select>
									</div>
									<div className="formRow border-0 ps-0">
										<label className="formLabel text-start mb-0 w-100">Game Name</label>
										<select className="formItem" value={gameName} onChange={(e) => setGameName(e.target.value)}>
											<option value={""}>All Games</option>
											{gameCollectionArray.map((item, index) => (
												<option key={index} value={item.value}>
													{item.label}
												</option>
											))}
										</select>
									</div>
									<div className="formRow border-0 ps-0">
										<label className="formLabel text-start mb-0 w-100">Date Filter</label>
										<select className="formItem" value={dateRangeType} onChange={(e) => setDateRangeType(e.target.value)}>
											<option value="today">Today</option>
											<option value="yesterday">Yesterday</option>
											{/* <option value="7_days">Last 7 Days</option> */}
											<option value="this_week">This Week</option>
											<option value="last_week">Last Week</option>
											<option value="this_month">This Month</option>
											<option value="last_month">Last Month</option>
											{/* <option value="1_month">Last 1 Month</option> */}
											{/* <option value="3_month">Last 3 Months</option> */}
										</select>
									</div>
									<div className="formRow border-0 ps-0">
										<label className="formLabel text-start mb-0 w-100">From Date</label>
										<div className="d-flex w-100">
											<input
												type="date"
												className="formItem"
												value={reportDate.startDate}
												onChange={(e) =>
													setReportDate((prev) => ({
														...prev,
														startDate: formatDateLocalNoTime(new Date(e.target.value)),
													}))
												}
											/>
										</div>
									</div>
									<div className="formRow border-0 ps-0">
										<label className="formLabel text-start mb-0 w-100">To Date</label>
										<div className="d-flex w-100">
											<input
												type="date"
												className="formItem"
												value={reportDate.endDate}
												onChange={(e) =>
													setReportDate((prev) => ({
														...prev,
														endDate: formatDateLocalNoTime(new Date(e.target.value)),
													}))
												}
											/>
										</div>
									</div>
									<button type="button" className="panelButton mt-auto mb-2 ms-0" onClick={getReportByDate}>
										<span className="text">Search</span>
										<span className="icon">
											<SvgIcon name="search" />
										</span>
									</button>
								</div>
							</div>
							<div className="tableContainer">
								<table>
									<thead>
										<tr>
											<th style={{ width: "20px" }}>#</th>
											<th>GAME ID</th>
											<th>GAME NAME</th>
											<th>WIN NUMBER</th>
											<th>XBONUS</th>
											<th>BET AMOUNT</th>
											<th>WIN AMOUNT</th>
											<th>COMMISSION</th>
											<th>RESULT</th>
											<th>TICKET ID</th>
											<th>DATE TIME</th>
										</tr>
									</thead>
									<tbody>
										{agentReport && agentReport.length > 0 ? (
											agentReport
												.sort((a, b) => b.id - a.id)
												.map((item, index) => {
													const date = new Date(item.result_date);
													const time = new Date(item.result_time);
													const formattedDate = date.toLocaleDateString("en-US", {
														month: "short",
														day: "numeric",
														year: "numeric",
													});
													const formattedTime = time.toLocaleTimeString("en-US", {
														hour: "numeric",
														minute: "2-digit",
														hour12: true,
													});
													const commission = parseFloat(commisionpoint);
													const ntp = (item.winrs - (commission / 100) * item.winrs).toFixed(2);
													const result = cardArray.find((card) => card.nCardId == item.result);
													const ntpPercent = (((item.total - item.winrs) / item.total) * 100).toFixed(2);
													return (
														<tr>
															<td style={{ width: "20px" }}>{index + 1}</td>
															<td>{item?.game_id}</td>
															<td>{gameCollectionArray?.find((game) => game.value == item?.gamename)?.label}</td>
															<td>
																{item?.gamename === "joker12card" || gameName === "joker12card" || item?.gamename === "joker16card" || gameName === "joker16card" ? (
																	result ? (
																		<div className="resultBlock">
																			<label>{result?.name?.substring(0, 1)}</label>
																			<img className="ms-1" style={{ width: "15px" }} src={`/assets/images/report/${result?.name?.substring(1)}.png`} />
																		</div>
																	) : (
																		"N/A"
																	)
																) : (
																	<label>{item?.result?.substring(1)}</label>
																)}
															</td>
															<td>{parseInt(item?.multiplier) == 1 ? "N" : parseInt(item?.multiplier) + "X"}</td>
															<td>{item?.totalbet}</td>
															<td>{item?.winamount || 0}</td>
															<td>{item?.commission || 0}</td>
															<td>{item?.status}</td>
															<td>
																{/* <a href="#" onClick={() => setSelectedItem(item)}> */}
																{item?.barcode}
																{/* </a> */}
															</td>
															<td>
																{formattedDate}, {item.result_time}
															</td>
														</tr>
													);
												})
										) : (
											<tr>
												<td colSpan={99} className="text-center">
													No Data Found
												</td>
											</tr>
										)}
										<tr
											style={{
												position: "sticky",
												bottom: "-5px",
												backgroundColor: "#fff",
											}}
										>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
											<td className="fw-bold">TOTAL: {agentReport?.reduce((sum, item) => sum + (item?.totalbet || 0), 0)}</td>
											<td className="fw-bold">WON: {agentReport?.reduce((sum, item) => sum + (item?.winamount || 0), 0)}</td>
											<td className="fw-bold">COMM: {agentReport?.reduce((sum, item) => sum + (item?.commission || item?.totalcommission || 0), 0)}</td>
											<td></td>
											<td></td>
											<td></td>
											{agentReport.some((x) => x.user_count) ? <td></td> : ""}
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
			{selectedItem?.barcode && <VirtualTicketDetails selectedItem={selectedItem} setSelectedItem={setSelectedItem} />}
		</>
	);
}

export default BetHistory;

const VirtualTicketDetails = ({ selectedItem, setSelectedItem }) => {
	const [ticketData, setTicketData] = useState([]);

	useEffect(() => {
		if (selectedItem.barcode) {
			fetchTicketDetails();
		}
	}, [selectedItem]);

	const fetchTicketDetails = async () => {
		const preparedData = {
			barcode: selectedItem.barcode,
		};
		const port = gamePorts[gameCollectionArray.find((item) => item.value === selectedItem.gamename)?.value];
		try {
			const response = await generalPostFunction("/getticketbybarcode", preparedData, `${port}`);
			if (response.length > 0) {
				setTicketData(response[0]);
			}
		} catch (err) {
			console.log(err);
		}
	};

	return (
		<>
			<div className="detailedBetData">
				<div className="wrapper">
					<button className="clearButton2" onClick={() => setSelectedItem({})} style={{ position: "absolute", top: 0, right: 0 }}>
						X
					</button>
					<div className="container">
						<div className="row align-items-center">
							<div className="col-4">
								<div className="resultBlock">
									<div className="winningCard">
										{selectedItem.gamename === "card12" || selectedItem.gamename === "card16" ? (
											<div className={"cardWrapper"}>
												<img src={`/assets/images/games/joker12card/${cardArray.find((card) => card.nCardId == selectedItem.result)?.name}.png`} />
											</div>
										) : selectedItem.gamename === "spin2win" ? (
											<div className={"cardWrapper"}>
												<img src={`/assets/images/games/spin2win/${selectedItem.result}.png`} />
											</div>
										) : selectedItem.gamename === "doublechance" ? (
											<div className={`doubleChance card`}>{selectedItem.result.substring(1).padStart(2, "0")}</div>
										) : (
											selectedItem.result
										)}
									</div>
									<div style={{ marginTop: "15px" }}>
										<ul>
											{selectedItem.result ? (
												<li>
													Result:{" "}
													{selectedItem.gamename === "card12" || selectedItem.gamename === "card16" ? (
														<label>{cardArray.find((card) => card.nCardId == selectedItem.result)?.name}</label>
													) : selectedItem.gamename === "zerotonine" ? (
														<label>{selectedItem.result.substring(1)}</label>
													) : selectedItem.gamename === "doublechance" ? (
														<label>{selectedItem.result.substring(1).padStart(2, "0")}</label>
													) : (
														<label>{selectedItem.result.substring(1)}</label>
													)}
												</li>
											) : (
												<li>Result: Pending</li>
											)}
											<li>Status: {ticketData.status}</li>
											<li>Win Points: {ticketData.winamount}</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="col">
								<div className="ticket">
									<div className="row pt-0 mt-0">
										<div className="heading text-start">
											<h4 className="mb-0" style={{ fontWeight: 700 }}>
												PaisaJeeto
											</h4>
											<p className="mb-0" style={{ fontWeight: 700 }}>
												FOR ENTERTAINMENT ONLY
											</p>
										</div>
										<div className="col-12 text-start">
											<div>
												<label>
													Draw Time:{" "}
													{new Date(ticketData?.result_date).toLocaleDateString("en-US", {
														month: "short",
														day: "numeric",
														year: "numeric",
													})}
													, {ticketData.result_time}
												</label>
											</div>
										</div>
										<div className="col-12 text-start d-flex justify-content-between">
											<div>
												<label>TERMINAL ID : {ticketData?.username}</label>
											</div>
											<div>
												<label>
													Game Name:{" "}
													{selectedItem.gamename === "card12"
														? "12 Card"
														: selectedItem.gamename === "spin2win"
															? "Spin 2 Win"
															: selectedItem.gamename === "doublechance"
																? "2 Digit 2"
																: selectedItem.gamename === "card16"
																	? "16 Card"
																	: selectedItem.gamename}
												</label>
											</div>
										</div>
										<div className="listType">
											<ul>
												{ticketData?.bets
													? Object?.entries(JSON.parse(ticketData?.bets))?.map(([key, value], index) => (
															<li key={key}>
																{selectedItem.gamename === "card12" || selectedItem.gamename === "card16" ? (
																	<span>
																		{cardArray.find((card) => card.nCardId == key)?.name}: {value}
																	</span>
																) : (
																	<span>
																		{index}: {value}
																	</span>
																)}
															</li>
														))
													: ""}
											</ul>
										</div>
										<div className="text-center">
											<label>
												<span>
													{selectedItem.gamename == "doublechance" ? "Qty" : "Total Pts"} : {ticketData?.totalbet}
												</span>
												{selectedItem.gamename == "doublechance" && <span className="ms-2">, Total Pts : {ticketData?.totalbet * 2}</span>}
											</label>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
